<template>
    <el-dialog
        class="edit-order-sku"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Order SKU"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Shop" prop="shop_id" size="small">
                            <el-select
                                v-model="editForm.shop_id"
                                size="small"
                                clearable
                                filterable
                                placeholder="Placeholder Shop"
                            >
                                <el-option
                                    v-for="item in shopList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" prop="sku" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.sku"
                                placeholder="Please input SKU"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="Goods Name"
                            prop="name"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.name"
                                placeholder="Please input Goods Name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Qty" prop="qty" size="small">
                            <el-input
                                type="number"
                                clearable
                                size="small"
                                v-model="editForm.qty"
                                placeholder="Please input Qty"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Price" prop="price" size="small">
                            <el-input
                                clearable
                                size="small"
                                v-model="editForm.price"
                                placeholder="Please input Price"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            },
            rules: {
                shop_id: [
                    {
                        required: true,
                        message: "Please input shop",
                    },
                ],
                sku: [
                    {
                        required: true,
                        message: "Please input sku",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "Please select goods name",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.editForm = {
                shop_id: "",
                sku: "",
                name: "",
                price: "",
                qty: "",
            };
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .shopOrderSku(
                            {
                                ...this.editForm,
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        shopOrderSku() {
            cmofferApi
                .shopOrderSku({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        let { data } = res;
                        this.editForm = {
                            shop_id: data.shop_id,
                            sku: data.sku,
                            name: data.name,
                            price: data.price,
                            qty: data.qty,
                        };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
        shopList: () => Array,
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.shopOrderSku();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.edit-order-sku {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
